import { SessionProvider } from 'next-auth/react';
import { useEffect } from 'react';
import { ExperimentProps } from 'src/services/experiments/types';
import { ExperimentProvider } from 'src/providers/ExperimentProvider';
import { GraphqlProvider } from 'src/providers/GraphqlProvider';
import { PossibleZillowSession } from 'src/services/auth/types';
import { FunctionComponentWithChildren } from 'src/utils/types';
import { PREFIXED_ROUTES } from 'src/common/constants';
import { useMigrateToZillowState } from 'src/experiences/MigrateToZillow/useMigrateToZillowState';
import { WiredZillowNavbar } from 'src/components/ZillowNavbar';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { globalErrorHandler } from 'src/common/globalErrorHandler';
import { DEPLOYMENT_ENVIRONMENT } from 'env/environments';
import { DevEnvironmentWarning } from 'src/components/DevEnvironmentWarning';
import { AnalyticsProvider } from './AnalyticsProvider';

export const UniversalWrappers: FunctionComponentWithChildren<
    {
        session: PossibleZillowSession;
    } & ExperimentProps
> = ({ session, children, ...rest }) => {
    useMigrateToZillowState();
    useEffect(() => {
        window.addEventListener('error', globalErrorHandler);
        return () => {
            window.removeEventListener('error', globalErrorHandler);
        };
    });
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    const { ENV } = publicRuntimeConfig;
    return (
        // check both because origin is server side, but currentOrigin is client side
        <GraphqlProvider>
            <SessionProvider basePath={`${PREFIXED_ROUTES.API_BASE}/auth`} refetchOnWindowFocus session={session}>
                <ExperimentProvider {...rest}>
                    <AnalyticsProvider>
                        <WiredZillowNavbar env={ENV} version={HEADER_VERSIONS.ZHL_DEFAULT} />
                        {ENV === DEPLOYMENT_ENVIRONMENT.DEVELOPMENT && <DevEnvironmentWarning />}
                        {children}
                    </AnalyticsProvider>
                </ExperimentProvider>
            </SessionProvider>
        </GraphqlProvider>
    );
};
